module.exports = require("readline");


//////////////////
// WEBPACK FOOTER
// external "readline"
// module id = 75
// module chunks = 0